import store from '../../../../src/store/store.js'
const { permissions } = store.state.AppActiveUser

const dashboard = {
  url: null,
  name: 'สรุปยอด',
  slug: '',
  icon: 'HomeIcon',
  submenu: [
    {
      url: '/',
      name: 'สรุปยอดรายวัน',
      slug: 'dashboard'
    },
    {
      url: '/month',
      name: 'สรุปยอดเดือน',
      slug: 'month'
    },
    {
      url: '/month23h',
      name: 'สรุปยอดเดือน 5 ทุ่ม',
      slug: 'month23h'
    }
  ]
}

const allies = {
  url: '/allies',
  name: 'สรุปยอดพันธมิตร',
  slug: 'allies',
  icon: 'PercentIcon'
}

const user = {
  url: '/member',
  name: 'ข้อมูลยูสเซอร์',
  slug: 'member',
  icon: 'UsersIcon',
  submenu: [
    {
      url: '/membersearch',
      name: 'ค้นหาข้อมูลยูสเซอร์',
      slug: 'membersearch'
    },
    {
      url: '/member/top-balance',
      name: '20 เครดิตสูงสุด',
      slug: 'topbalance'
    }
  ]
}

const addcredit = {
  url: '/agent',
  name: 'เติม-ถอน เครดิต',
  slug: 'agent',
  icon: 'CreditCardIcon'
}

const minuscredit = {
  url: '/agentminus',
  name: 'ถอน เครดิต',
  slug: 'agentminus',
  icon: 'CreditCardIcon'
}

const topup = {
  url: '/topup',
  name: 'รายการเพิ่มเครดิต',
  slug: 'topup',
  icon: 'PlusCircleIcon'
}

const trxtransfer = {
  url: '/trxtransfer',
  name: 'รายการโยกเงิน UFA',
  slug: 'trxtransfer',
  icon: 'ListIcon'
}

const withdraw = {
  url: null,
  name: 'รายการถอนเงิน',
  slug: '',
  icon: 'MinusCircleIcon',
  submenu: [
    {
      url: '/withdraw',
      name: 'รอทำรายการ',
      slug: 'withdraw'
    },
    {
      url: '/withdrawwait/error',
      name: 'ถอนไม่สำเร็จ',
      slug: 'withdrawerror'
    },
    {
      url: '/withdrawlist',
      name: 'ประวัติทำรายการ',
      slug: 'withdrawlist'
    },
    {
      url: '/withdrawwait/pending',
      name: 'รอถอน Payment',
      slug: 'withdarwpending'
    },
    {
      url: '/withdrawwait/confirm/all',
      name: 'รอตรวจสอบ',
      slug: 'withdrawwaitConfrim'
    }
  ]
}

const bankv2 = {
  url: '/bankV2',
  name: 'รายการ ธนาคาร',
  slug: 'bank',
  icon: 'DollarSignIcon'
}

// Payment submenu เริ่มต้น (fallback เมื่อ API ยังโหลดไม่เสร็จ)
export const DEFAULT_PAYMENT_SUBMENU = [
  { url: '/pompay', name: 'รายการฝาก POMPAY', slug: 'pompay', icon: 'DollarSignIcon' },
  { url: '/fpayment', name: 'รายการฝาก FPAYMENT', slug: 'fpayment' },
  { url: '/mtp', name: 'รายการฝาก MTP', slug: 'mtp' },
  { url: '/akpay', name: 'รายการฝาก AK', slug: 'akpay' },
  { url: '/gin', name: 'รายการฝาก GIN', slug: 'gin' },
  { url: '/payment-transaction/wildpay', name: 'รายการฝาก WILDPAY', slug: 'wildpay' },
  { url: '/payment-transaction/richpay', name: 'รายการฝาก RICHPAY', slug: 'richpay' },
  { url: '/payment-transaction/kingpay', name: 'รายการฝาก KINGPAY', slug: 'kingpay' },
  { url: '/payment-transaction/jaipay', name: 'รายการฝาก JAIPAY', slug: 'jaipay' },
  { url: '/payment-transaction/gtpay', name: 'รายการฝาก GTPAY', slug: 'gtpay' },
  { url: '/payment-transaction/tlpay', name: 'รายการฝาก TLPAY', slug: 'tlpay' },
  { url: '/payment-transaction/bdpay', name: 'รายการฝาก BDPAY', slug: 'bdpay' },
  { url: '/payment-transaction/livepay', name: 'รายการฝาก LIVEPAY', slug: 'livepay' },
  { url: '/payment-transaction/wpay', name: 'รายการฝาก WPAY', slug: 'wpay' }
]

const getPaymentMenu = (paymentNavItems) => ({
  url: null,
  name: 'รายการ Payment',
  slug: 'payment',
  icon: 'DollarSignIcon',
  submenu: (paymentNavItems && paymentNavItems.length > 0) ? paymentNavItems : DEFAULT_PAYMENT_SUBMENU
})

const pay2coin = {
  url: null,
  name: 'รายการฝาก Pay2Coin',
  slug: 'pay2coin',
  icon: 'DollarSignIcon',
  submenu: [
    {
      url: '/pay2coin',
      name: 'รายการฝาก Pay2coin',
      slug: 'pay2coin'
    },
    {
      url: '/pay2coin-dashboard',
      name: 'ระบบหลังบ้าน Pay2coin',
      target: '_blank',
      slug: 'pay2coin'
    }
  ]
}


const callcenter = {
  url: null,
  name: 'รายการ Callcenter',
  slug: 'callcenter',
  icon: 'PhoneIcon',
  submenu: [
    {
      url: '/callcenter-list',
      name: 'รายการ Callcenter',
      slug: 'callcenter-list'
    },
    {
      url: '/callcenter-confirm',
      name: 'รายการ Confirm',
      slug: 'callcenter'
    },
    {
      url: '/callcenter-setting',
      name: 'รายการ setting',
      slug: 'callcenter-setting'
    }
  ]
}

const truewallet = {
  url: '/wallet',
  name: 'รายการ Truewallet',
  slug: 'wallet',
  icon: 'ListIcon'
}

const settingBankShow = {
  url: '/SettingBank',
  name: 'ตั้งค่าการโชว์ธนาคาร',
  slug: 'SettingBank',
  icon: 'SettingsIcon'
}

const setting = {
  url: null,
  name: 'ตั้งค่าระบบ',
  slug: '',
  icon: 'SettingsIcon',
  submenu: [
    {
      url: '/SettingSystem',
      name: 'ระบบ หน้าเว็บ',
      slug: 'settingsystem'
    },
    {
      url: '/setting-payment',
      name: 'ระบบ Payment',
      slug: 'settingPayment'
    },
    {
      url: '/SettingWithdraw',
      name: 'ระบบ ถอนเงิน',
      slug: 'settingwithdraw'
    },
    {
      url: '/SettingPopup',
      name: 'ระบบ แจ้งเตือน',
      slug: 'popupsetting'
    },
    {
      url: '/SettingRanking',
      name: 'ระบบ Ranking',
      slug: 'SettingRanking'
    },
    {
      url: '/SettingMvp',
      name: 'ระบบ Mvp',
      slug: 'SettingMvp'
    },
    {
      url: '/SettingBlog',
      name: 'ระบบ บทความ',
      slug: 'SettingBlog'
    },
    {
      url: '/SettingRateCrypto',
      name: 'ระบบ Crypto Rate',
      slug: 'settingretecrypto'
    },
    {
      url: null,
      name: 'ระบบ บัญชี ',
      slug: 'Acc',
      submenu: [
        {
          url: '/SettingWalletDepositV2',
          name: 'บัญชีฝาก',
          slug: 'settingwalletdepositV2'
        },
        {
          url: '/SettingWalletWithdrawV2',
          name: 'บัญชีถอน',
          slug: 'settingwalletwithdrawV2'
        },
        {
          url: '/SettingTruewalletV2',
          name: 'บัญชี Truewallet',
          slug: 'settingtruewalletV2'
        }
      ]
    }
  ]
}

const report = {
  url: null,
  name: 'รีพอร์ท',
  slug: 'report',
  icon: 'DownloadIcon',
  submenu: [
    {
      url: '/reportlogusage',
      name: 'ประวัติการใช้งาน',
      slug: 'reportlogusage'
    },
    {
      url: '/reportpromotion',
      name: 'โบนัส',
      slug: 'reportpromotion'
    },
    {
      url: '/reportaff',
      name: 'แนะนำเพื่อน',
      slug: 'reportaff'
    },
    {
      url: '/reportturn',
      name: 'รับเงินคืน',
      slug: 'reportturn'
    },
    {
      url: '/reportregister',
      name: 'สมัคร / เติมเงิน',
      slug: 'reportregister'
    },
    {
      url: '/reportminigame',
      name: 'เปิดไพ่ / กงล้อ',
      slug: 'reportminigame'
    },
    {
      url: '/reportactiveuser',
      name: 'Activeuser',
      slug: 'reportactiveuser'
    },
    {
      url: '/winloss',
      name: 'สรุปยอดสายบน',
      slug: 'winloss'
    },
    {
      url: '/ReportTournamentPnl',
      name: 'เกาจิ้งเมืองไทย',
      slug: 'Tournament'
    }
  ]
}

const admin = {
  url: '/settingstaff',
  name: 'ระบบ พนักงาน',
  slug: 'settingstaff',
  icon: 'SettingsIcon'
}

const creditfree = {
  url: null,
  name: 'รายการเครดิตฟรี',
  slug: '',
  icon: 'CreditCardIcon',
  submenu: [
    {
      url: '/creditfreewait',
      name: 'รอทำรายการ',
      slug: 'creditfreewait'
    },
    {
      url: '/creditfreelist',
      name: 'รายการเครดิตฟรี',
      slug: 'creditfreelist'
    },
    {
      url: '/creditfreeinfo',
      name: 'แก้ไขลิงค์',
      slug: 'creditfreeinfo'
    }
  ]
}

const review = {
  url: null,
  name: 'เพิ่ม-ลด รูปภาพ',
  slug: '',
  icon: 'ListIcon',
  submenu: [
    {
      url: '/review',
      name: 'คำชม',
      slug: 'review'
    },
    {
      url: '/jackpot',
      name: 'Jackpot',
      slug: 'jackpot'
    }
  ]
}

const audit = {
  url: null,
  name: 'ตรวจสอบบัญชีถอน',
  slug: '',
  icon: 'CreditCardIcon',
  submenu: [
    {
      url: '/checkbankwithdraw/account',
      name: 'รายการบัญชีถอน',
      slug: 'checkbankwithdraw/account'
    },
    {
      url: '/checkbankwithdraw/adjustbalance',
      name: 'เติม เครดิต',
      slug: 'checkbankwithdraw/adjustbalance'
    },
    {
      url: '/checkbankwithdraw/adjustwithdraw',
      name: 'เบิก เครดิต',
      slug: 'checkbankwithdraw/account'
    },
    {
      url: '/checkbankwithdraw/upslip',
      name: 'อัพสลิป',
      slug: 'checkbankwithdraw/upslip'
    }
  ]
}

const auditDeposit = {
  url: '/bankcompare',
  name: 'ตรวจสอบบัญชีฝาก',
  slug: 'bankcompare',
  icon: 'DollarSignIcon'
}

const accountManagementV2 = {
  url: null,
  name: 'โยกเงิน',
  slug: '',
  icon: 'CreditCardIcon',
  submenu: [
    {
      url: '/internal-transfer/manualV2',
      name: 'โยกเงิน',
      slug: 'internal-transfer/manualV2'
    },
    {
      url: '/internal-transfer/logs',
      name: 'ประวัติการโยกเงิน',
      slug: '/internal-transfer/logs'
    }
  ]
}

const temporary = {
  url: null,
  name: 'ตั้งค่าบัญชีพัก',
  slug: '',
  icon: 'SettingsIcon',
  submenu: [
    {
      url: '/SettingTemporary',
      name: 'รายการบัญชีพัก',
      slug: 'SettingTemporary'
    }
  ]
}

const agent = {
  url: '/games',
  name: 'ตั้งค่าระบบเกม',
  slug: '',
  icon: 'PlayCircleIcon',
  target: '_blank'
}

const settingSms = {
  url: '/SettingSms',
  name: 'ระบบ Sms',
  slug: 'SettingSms',
  icon: 'MessageCircleIcon'
}

function buildShowMenu (paymentNavItems = []) {
  const menu = []
  if (permissions) {
    if (permissions.dashboard && permissions.dashboard.read) menu.push(dashboard)
    if (permissions.allies && permissions.allies.read) menu.push(allies)
    if (permissions.user && permissions.user.read) menu.push(user)
    if (permissions.addcredit && permissions.addcredit.action) menu.push(addcredit)
    if (permissions.minuscredit && permissions.minuscredit.action) menu.push(minuscredit)
    if (permissions.topup && permissions.topup.read) menu.push(topup)
    menu.push(trxtransfer)
    if (permissions.withdraw && permissions.withdraw.read) menu.push(withdraw)
    if (permissions.bank && permissions.bank.read) menu.push(bankv2)
    if (permissions.payment && permissions.payment.read) menu.push(getPaymentMenu(paymentNavItems))
    if (permissions.payment && permissions.payment.read) menu.push(pay2coin)
    if (permissions.callcenter && permissions.callcenter.read) menu.push(callcenter)
    if (permissions.truewallet && permissions.truewallet.read) menu.push(truewallet)
    if (permissions.settingBankShow && permissions.settingBankShow.read) menu.push(settingBankShow)
    if (permissions.setting && permissions.setting.read) menu.push(setting)
    if (permissions.settingSms && permissions.settingSms.read) menu.push(settingSms)
    if (permissions.gameSetting && permissions.gameSetting.read) menu.push(agent)
    if (permissions.report && permissions.report.read) menu.push(report)
    if (permissions.admin && permissions.admin.read) menu.push(admin)
    if (permissions.creditfree && permissions.creditfree.read) menu.push(creditfree)
    if (permissions.review && permissions.review.read) menu.push(review)
    if (permissions.audit && permissions.audit.read) {
      menu.push(audit)
      menu.push(auditDeposit)
    }
    if (permissions.accountManagement && permissions.accountManagement.read) menu.push(accountManagementV2)
    if (permissions.temporary && permissions.temporary.read) menu.push(temporary)
  }
  menu.push(agent)
  return menu
}

export { buildShowMenu }
export default buildShowMenu(DEFAULT_PAYMENT_SUBMENU)
